



















import L from 'leaflet'
import {Component, Mixins, Prop} from 'vue-property-decorator';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import {LIcon, LMap, LMarker, LPopup, LTileLayer} from 'vue2-leaflet';
import {SVGPie} from "@/mixin/imports";
import SVGPieMixin from "@/mixin/SVGPie.vue";
import {ESettori, EUserType} from "@/types";
import {debounce, imgmarker} from "@/utils";

@Component({
    components: {
        LMap,
        LTileLayer,
        LMarker,
        L,
        LIcon,
        LPopup,
        Vue2LeafletMarkerCluster
    },
    name: "Map"
})
export default class Mappa extends Mixins<SVGPie>(SVGPieMixin) {
    @Prop(Number) private readonly defaultZoom!: number
    @Prop(Array) private readonly announcements!: any[]
    @Prop(Boolean) private readonly groupCompany!: boolean

    private center = L.latLng(43.8398731, 10.4766789)
    private zoom: number = this.defaultZoom || 10;
    private url = "https://{s}.tile.osm.org/{z}/{x}/{y}.png"

    private count = 0;

    get markers() {

        if (this.announcements) {
            if (this.groupCompany) {
                return this.announcements.map((a)=>{
                    return {
                        marker: new L.latLng(a.company.lat, a.company.lng),
                        id: a.id,
                        options: {tipologia: 0, settori: [a.settore]},
                        pupup: {
                            title: a.titolo,
                            description: a.company.nome_ragione_sociale,
                            to: { name: 'Announcement', params: { announcementUuid: a.id }},
                            label: 'Visualizza dettaglio annuncio'
                        }
                    }
                })

            } else {
                return this.announcements.map((a) => {
                    return {
                        marker: new L.latLng(a.lat, a.lng),
                        id: a.id,
                        options: {tipologia: 1, settori: [...a.settori].sort()},
                        pupup: {
                            title: a.nome + ' ' + a.cognome,
                            description: a.locality,
                            to: { name: 'Worker', params: { workerUuid: a.id }},
                            label:'Visualizza dettaglio risorsa'
                        }
                    };
                })
            }

        }
        return []
    }

    private f = debounce((self: any, animate?:boolean)=>{
            (self.$refs.map as any).mapObject.invalidateSize(animate)
        }, 50);

    public invalidate(animate?: boolean) {
        this.f(this, animate);
    }

    public zoomOut() {
        (this.$refs.map as any).mapObject.zoomOut()
    }

    public zoomIn() {
        (this.$refs.map as any).mapObject.zoomIn()
    }

    public fitBounds(corner1: any, corner2: any) {
        (this.$refs.map as any).mapObject.flyToBounds(L.latLngBounds(corner1, corner2))
    }

    private onMapReady(map: any) {
        this.$emit('update:bounds', map.getBounds())
    }

    private activated() {
        this.invalidate()
    }

    private getMarker(p: any) {
        if (p.options.tipologia == EUserType.Company) {
            return (imgmarker as any)['a' + p.options.settori.join('')];
        } else if (p.options.tipologia == EUserType.Worker) {
            return (imgmarker as any)['r' + p.options.settori.join('')];
        }
    }

    private iconCreateFunction(cluster: any) {
        //console.log(cluster.getAllChildMarkers())

        const qty = cluster.getAllChildMarkers().reduce((a: number[], b: any) => {
            b.options.settori.forEach((s: number) => {
                a[s]++
            })
            return a
        }, [0, 0, 0, 0])

        return L.divIcon({
            html: `<div class="cluster_container ` + (cluster.getChildCount() >= 100 ? 'big' : '') + `">` + this.makePiePath([
                {
                    amount: qty[ESettori.Ortofrutta],
                    dataSettore: ESettori.Ortofrutta
                },
                {
                    amount: qty[ESettori.Florovivaismo],
                    dataSettore: ESettori.Florovivaismo
                },
                {
                    amount: qty[ESettori.ViteOlivo],
                    dataSettore: ESettori.ViteOlivo
                },
                {
                    amount: qty[ESettori.Allevamento],
                    dataSettore: ESettori.Allevamento
                },

            ]) + `<span class="quantity">` + cluster.getChildCount() + `</span></div>`
        });
    }
}

